import * as React from "react";

export interface RefreshIconProps {
    title?: string;
    decorative: boolean;
}

const SvgIcnRefresh = (props: React.SVGProps<SVGSVGElement> & RefreshIconProps) => (
    <svg
        role="img"
        aria-hidden={props.decorative}
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        viewBox="0 0 20 20"
        {...props}
    >
        {props.title ? <title>{props.title}</title> : null}
        <path
            fill="currentColor"
            d="M7.802 4.25a6.002 6.002 0 014.009.212.5.5 0 00.383-.924 7.002 7.002 0 00-8.437 10.46H2a.5.5 0 100 1h2.766a.52.52 0 00.09 0H5a.5.5 0 00.5-.5v-3a.5.5 0 10-1 0v1.815A6.002 6.002 0 017.802 4.25zM14.5 8.499V6.683a6 6 0 01-7.31 8.856.5.5 0 10-.385.923 7 7 0 008.439-10.463H17a.5.5 0 000-1h-2.767a.503.503 0 00-.09 0H14a.5.5 0 00-.5.5v3a.5.5 0 001 0z"
        />
    </svg>
);

export default SvgIcnRefresh;
